export function unique(array, comparer = (x, y) => x === y) {
  return array.filter((x, index, self) => self.findIndex(y => comparer(x, y)) === index)
}

export function compact(array) {
  return array.filter(x => x)
}
